<template>
    <section>
        <div class="page-content">
            <div class="header-col">
                <div class="row align-items-center">
                    <div class="col-auto">
                        <div class="logo">
                            <a :href="route('home')"><img src="/admin_stylesheet/images/logo.svg" alt="..."></a>
                        </div>
                    </div>
                    <div class="col d-block d-lg-none">
                        <div class="arrow-back">
                            <a href="javascript:void(0);"><span><i class="feather-chevron-left"></i></span>Back to website</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row g-0 mh-100">
                <div class="col-lg-7 mh-100 order-lg-last">
                    <slot></slot>
                </div>
                <div class="col-lg-5 mh-100 overlay-col d-none d-lg-block">
                    <div class="web-col">
                        <span class="dots-shape"><img src="/admin_stylesheet/images/dots-shape.svg" alt="..."></span>
                        <div class="web-content">
                            <p>
                                Helmbay is a SaaS that provides ways to privately store and distribute Helm charts for their apps.
                                It makes it fast and easy to deploy your apps into Kubernetes.
                            </p>
                        </div>
                        <span class="circle-shape"><img src="/admin_stylesheet/images/circle-shape.svg" alt="..."></span>
                        <span class="user-shape"><img src="/admin_stylesheet/images/tree-structure.svg" alt="..."></span>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>


<script>
    export default {
        components: {},

        data() {
            return {}
        },

        methods: {

        }
    }
</script>
